import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/xjhlt',
            name: 'xuejinghanlintu',
            component: () =>
                import(/* webpackChunkName: "xuejinghanlintu" */ '@page/xuejinghanlintu/Index'),
            meta: {
                title: '雪景寒林图',
            },
        },
        {
            path: '/youcai',
            name: 'youcai',
            component: () =>
                import(/* webpackChunkName: "youcai" */ '@page/youcai/Index'),
            meta: {
                title: '测一测，你的审美价值多少',
            },
        },
        {
            path: '/h',
            name: 'h',
            component: () =>
                import(/* webpackChunkName: "h" */ '@page/demo/index'),
        },
        {
            path: '/demo',
            name: 'demo',
            component: () =>
                import(/* webpackChunkName: "demo" */ '@page/demo/demo'),
        },
        {
            path: '/guessdifferent',
            component: () =>
                import(/* webpackChunkName: "guessDifferent-view" */ '@page/guessDifferent/Index'),
            meta: {
                title: '鉴宝师培养计划',
            },
            children: [
                {
                    path: '/',
                    name: 'guessDifferentHomePage',
                    component: () =>
                        import(/* webpackChunkName: "guessDifferentHomePage-view" */ '@page/guessDifferent/HomePage'),
                },
                {
                    path: 'museum',
                    name: 'guessDifferentMuseum',
                    component: () =>
                        import(/* webpackChunkName: "guessDifferentMuseum-view" */ '@page/guessDifferent/Museum'),
                },
                {
                    path: 'level',
                    name: 'guessDifferentLevel',
                    component: () =>
                        import(/* webpackChunkName: "guessDifferentLevel-view" */ '@page/guessDifferent/Level'),
                },
                {
                    path: 'detail',
                    name: 'guessDifferentDetail',
                    component: () =>
                        import(/* webpackChunkName: "guessDifferentDetail-view" */ '@page/guessDifferent/Detail'),
                },
            ],
        },
        {
            path: '/shuiyi',
            redirect: '/shuiyi/default',
        },
        {
            path: '/shuiyi/:source',
            name: 'shuiyi',
            component: () =>
                import(/* webpackChunkName: "shuiyi" */ '@page/shuiyi/Index'),
            meta: {
                title: '如果朋友圈的好友都说真话...',
            },
        },
        {
            path: '/flower',
            name: 'flower',
            component: () =>
                import(/* webpackChunkName: "flower" */ '@page/flower/Index'),
            meta: {
                title: '用花艺寻觅你的意中人',
            },
        },
        {
            path: '/msllsy',
            name: 'msllsy',
            component: () =>
                import(/* webpackChunkName: "shuiyihecheng" */ '@page/msllsy/Index'),
            meta: {
                title: '梅上绫罗',
            },
        },
        {
            path: '/ancientOffer',
            redirect: '/ancientOffer/default',
        },
        {
            path: '/ancientOffer/:source',
            name: 'ancientOffer',
            component: () =>
                import(/* webpackChunkName: "ancientOffer" */ '@page/ancientOffer/Index'),
            meta: {
                title: '测测你在古代能拿什么offer？',
            },
        },
        {
            path: '/discountLogin',
            redirect: '/discountLogin/default',
        },
        {
            path: '/discountLogin/:source',
            name: 'discountLogin',
            component: () =>
                import(/* webpackChunkName: "discountLogin" */ '@page/discountCoupon/index'),
            meta: {
                title: '文物加端午礼包',
            },
        },
        {
            path: '/discount/activeRules',
            name: 'discountActiveRules',
            component: () =>
                import(/* webpackChunkName: "discountActiveRules" */ '@page/discountCoupon/activeRules'),
            meta: {
                title: '活动规则',
            },
        },
        {
            path: '/discount/download',
            name: 'discountDownload',
            component: () =>
                import(/* webpackChunkName: "discountDownload" */ '@page/discountCoupon/download'),
            meta: {
                title: '下载文物加APP',
            },
        },
        {
            path: '/giftBag',
            redirect: '/giftBag/default',
        },
        {
            path: '/giftBag/:source',
            name: 'giftBag',
            component: () =>
                import(/* webpackChunkName: "giftBag" */ '@page/giftBag/index'),
            meta: {
                title: '文物加礼包',
            },
        },
        {
            path: '/gift/activeRules',
            name: 'giftActiveRules',
            component: () =>
                import(/* webpackChunkName: "giftActiveRules" */ '@page/giftBag/activeRules'),
            meta: {
                title: '活动规则',
            },
        },
        {
            path: '/gift/download',
            name: 'giftDownload',
            component: () =>
                import(/* webpackChunkName: "giftDownload" */ '@page/giftBag/download'),
            meta: {
                title: '下载文物加APP',
            },
        },
        // 轮盘抽奖
        {
            path: '/summerprize',
            redirect: '/summerprize/default',
        },
        {
            path: '/summerprize/:source',
            name: 'summerprize',
            component: () =>
                import(/* webpackChunkName: "circleprize" */ '@page/summerprize'),
            meta: {
                title: '测测你在古代夏天能坚持多久？',
            },
        },
        {
            path: '/circleprize',
            name: 'circleprize',
            component: () =>
                import(/* webpackChunkName: "circleprize" */ '@page/summerprize/circleprize'),
            meta: {
                title: '抽奖',
            },
        },
        //新抽奖

        {
            path: '/julydraw/:source?',
            name: 'julydraw',
            component: () =>
                import(/* webpackChunkName: "julydraw" */ '@/page/julydraw'),
            meta: {
                title: '0元定制大礼包，100%中奖等你来拿',
            },
        },

        {
            path: '/chinajoyticket/:id?',
            name: 'chinajoyticket',
            component: () =>
                import(/* webpackChunkName: "chinajoyticket" */ '@/page/chinajoyticket'),
        },
        {
            path: '/verifyUser/s',
            name: 'verifyUser',
            // redirect: "/chinajoyticket/phone",
            component: () =>
                import(/* webpackChunkName: "chinajoyticket" */ '@/page/chinajoyticket/verifyUser/verifyUser'),
        },
        {
            path: '/verifyUser/ss',
            name: 'verifyUserSecond',
            // redirect: "/chinajoyticket/bag",
            component: () =>
                import(/* webpackChunkName: "chinajoyticket" */ '@/page/chinajoyticket/verifyUser/verifyUserSecond'),
        },
        {
            path: '/verifyUser/sss',
            name: 'verifyUserThird',
            // redirect: "/chinajoyticket/shirt",
            component: () =>
                import(/* webpackChunkName: "chinajoyticket" */ '@/page/chinajoyticket/verifyUser/verifyUserThird'),
        },

        {
            path: '/yellowposter',
            name: 'yellowposter',
            component: () =>
                import(/* webpackChunkName: "yellowposter" */ '@page/marketact/yellowposter'),
        },
        {
            path: '/midFestival/:source?',
            name: 'midFestival',
            component: () =>
                import(/* webpackChunkName: "midFestival" */ '@page/midFestival/index'),
            meta: {
                title: '中秋礼包',
            },
        },
        {
            path: '/mid/activeRules',
            name: 'midActiveRules',
            component: () =>
                import(/* webpackChunkName: "midActiveRules" */ '@page/midFestival/activeRules'),
            meta: {
                title: '活动规则',
            },
        },
        {
            path: '/arithmetic',
            redirect: '/arithmetic/default',
        },
        {
            path: '/arithmetic/:source',
            name: 'arithmetic',
            component: () =>
                import(/* webpackChunkName: "arithmetic" */ '@page/arithmetic/index'),
            meta: {
                title: '求签活动',
            },
        },
        {
            path: '/springfes',
            redirect: '/springfes/default',
        },
        {
            path: '/springfes/:source',
            name: 'springfes',
            component: () =>
                import(/* webpackChunkName: "springfes" */ '@page/springfes/index'),
            meta: {
                title: '我也“壳”以很国潮',
            },
        },
        {
            path: '/collectCards',
            redirect: '/collectCards/default',
        },
        {
            path: '/collectCards/:source',
            name: 'collectCards',
            component: () =>
                import(/* webpackChunkName: "collectCards" */ '@page/collectCards/index'),
            meta: {
                title: '集卡领红包',
            },
        },
        {
            path: '/cards/share',
            name: 'share',
            component: () =>
                import(/* webpackChunkName: "share" */ '@page/collectCards/components/share'),
            meta: {
                title: '集卡领红包',
            },
        },
        {
            path: '/museum',
            name: 'museum',
            component: () =>
                import(/* webpackChunkName: "museum" */ '@page/museum/index'),
            meta: {
                title: '主题博物馆',
            },
        },
        {
            path: '/mid/download',
            name: 'midDownload',
            component: () =>
                import(/* webpackChunkName: "midActiveRules" */ '@page/midFestival/download'),
            meta: {
                title: '下载文物加APP',
            },
        },
        {
            path: '/canvastest',
            name: 'canvastest',
            component: () =>
                import(/* webpackChunkName: "canvastest" */ '@page/canvastest/test'),
            meta: {
                title: 'canvas下载测试',
            },
        },
        {
            path: '/productList/:id',
            name: 'productList',
            component: () =>
                import(/* webpackChunkName: "productList" */ '@page/theme-museum/productList'),
        },
        {
            path: '/beer-announce',
            name: 'beer-announce',
            component: () =>
                import(/* webpackChunkName: "beer-announce" */ '@page/theme-museum/beer-announce'),
        },
        {
            path: '/votePage',
            name: 'votePage',
            component: () =>
                import(/* webpackChunkName: "vote" */ '@page/vote'),
        },
        {
            path: '/activeDeploy',
            name: 'activeDeploy',
            component: () =>
                import(/* webpackChunkName: "activeDeploy" */ '@page/activeDeploy'),
        },
    ],
});
